// extracted by mini-css-extract-plugin
export default {"table-body-row":"styles_table-body-row__3omjQ","container":"styles_container__5g3gR"};